import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class RightLinks extends Component {
  render() {
    const { s, data, handleClickQuestion } = this.props;
    return (
      <div className={s.rightLinks}>
        <div style={{ flex: 1 }}>
          <div className={s.title}>热点问题</div>
          <div className={s.docTip}>
            <ol>
              {data.map(({ title }) => (
                <li key={title} onClick={() => handleClickQuestion(title)}>
                  {title}
                </li>
              ))}
            </ol>
          </div>
        </div>
        <div className={s.divider} />
        <div className={s.title}>权威发布</div>
        <div className={s.links}>
          <div>
            <a
              href="http://gjzwfw.www.gov.cn/fwmh/item/indexTrainItemList/540100.do?isGrOrFr=1&subjectCode=075"
              target="_blank"
              className={s.b0}
            >
              <img src="/assets/images/icon/lasa/zfbz.png" alt="" />
              <div>住房保障</div>
            </a>
          </div>
          <div>
            <a
              className={s.b1}
              href="http://gjzwfw.www.gov.cn/fwmh/item/indexTrainItemList/540100.do?isGrOrFr=1&subjectCode=145"
              target="_blank"
            >
              <img src="/assets/images/icon/lasa/ylws.png" alt="" />
              <div>医疗卫生</div>
            </a>
          </div>
          <div>
            <a
              className={s.b2}
              target="_blank"
              href="http://gjzwfw.www.gov.cn/fwmh/item/indexTrainItemList/540100.do?isGrOrFr=1&subjectCode=060"
            >
              <img src="/assets/images/icon/lasa/hydj.png" alt="" />
              <div>婚姻登记</div>
            </a>
          </div>
          <div>
            <a
              className={s.b3}
              target="_blank"
              href="http://gjzwfw.www.gov.cn/fwmh/item/indexTrainItemList/540100.do?isGrOrFr=2&subjectCode=005"
            >
              <img src="/assets/images/icon/lasa/slbg.png" alt="" />
              <div>设立变更</div>
            </a>
          </div>
          <div>
            <a
              className={s.b4}
              target="_blank"
              href="http://gjzwfw.www.gov.cn/fwmh/item/indexTrainItemList/540100.do?isGrOrFr=2&subjectCode=040"
            >
              <img src="/assets/images/icon/lasa/tzsp.png" alt="" />
              <div>投资审批</div>
            </a>
          </div>
          <div>
            <a
              className={s.b5}
              href="http://gjzwfw.www.gov.cn/fwmh/item/indexTrainItemList/540100.do?isGrOrFr=2&subjectCode=125"
              target="_blank"
            >
              <img src="/assets/images/icon/lasa/zscq.png" alt="" />
              <div>知识产权</div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

RightLinks.propTypes = {
  s: PropTypes.shape().isRequired,
  handleClickQuestion: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
};
